import React, { Fragment } from 'react'
import styles from './TitleLine.module.scss'
import { PageTopContainer } from 'pages/utils'
import { ValueLabel } from 'components'
import { Props } from './types'
import { VIEWERS_STORE } from 'store'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'

const TitleLineComponent = (props: Props) => {
  const {
    [VIEWERS_STORE]: { viewerPageTitleProps }
  } = props

  return (
    <PageTopContainer className={styles.titleContainer}>
      <h3>{viewerPageTitleProps.title}</h3>
      <ValueLabel
        label={viewerPageTitleProps.label}
        value={<Fragment>
          {viewerPageTitleProps.value.split(' ').map((v, i) => (
            <Fragment key={i}>
              {i % 2
                ? v
                : <span>{v}</span>
              }
            </Fragment>
          ))}
        </Fragment>}
      />
    </PageTopContainer>
  )
}

const TitleLine = inject(VIEWERS_STORE)(observer(TitleLineComponent))
export { TitleLine }
